<footer class="general-footer">
  <div class="general-footer__inner">
    <a href="/" class="general-footer__logo">
      <img
        ngSrc="assets/images/logo-sm.png"
        priority="high"
        alt="RedRock logo"
        routerLink="/"
        height="40"
        width="90"
      />
    </a>

    <div class="general-footer__links">
      <ul class="general-footer__links-group">
        <li class="general-footer__links-item">
          <a
            [attr.href]="termsOfUseUrl"
            class="general-footer__link"
            target="_blank"
          >
            {{ 'general-footer.terms-of-use' | translate }}
          </a>
        </li>
        <li class="general-footer__links-item">
          <a
            [attr.href]="participationAgreementUrl"
            class="general-footer__link"
            target="_blank"
          >
            {{ 'general-footer.pool-participation-agreement' | translate }}
          </a>
        </li>
      </ul>
    </div>

    <div class="general-footer__links">
      <ul class="general-footer__links-group">
        <li class="general-footer__links-item">
          <a
            [attr.href]="privacyPolicyUrl"
            class="general-footer__link"
            target="_blank"
          >
            {{ 'general-footer.privacy-policy' | translate }}
          </a>
        </li>
        <li class="general-footer__links-item">
          <a
            [attr.href]="cookiePolicyUrl"
            class="general-footer__link"
            target="_blank"
          >
            {{ 'general-footer.cookie-policy' | translate }}
          </a>
        </li>
      </ul>
    </div>

    <lib-button
      class="general-footer__help-button"
      buttonStyle="primary"
      buttonSize="medium"
      (click)="openSupport()"
    >
      {{ 'general-footer.need-help-button' | translate }}
    </lib-button>
  </div>
</footer>
